/**
 * 레벨 배럴 — 게임·에디터·도구가 레벨 심볼을 읽는 곳. **지금 고른 에피소드**의 레벨을 가리킨다.
 *
 * 값은 전부 `export let` 이다(ES 모듈 live binding). `setLevel()` 로 다른 번들을 꽂으면 이 파일을 import 한
 * 모든 모듈이 그 번들을 보게 된다 — 에피소드를 고르는 것은 `shared/episode-registry.ts` 의 `useEpisodeLevel(id)`.
 * 기본값은 사흘(saholv7). 새 에피소드의 번들은 `LevelBundle`(= 사흘 번들의 모양)을 그대로 따라야 한다.
 *
 * ⚠️ 모듈 최상단(로드 시점)에서 이 값들을 읽어 캐시하지 말 것 — 에피소드를 고르기 전의 값이 박힌다.
 * ⚠️ **서버는 이 배럴을 쓰지 않는다.** 한 isolate 가 여러 방(에피소드)을 돌리므로 전역을 바꾸면 섞인다.
 *    서버는 `EPISODE_SOURCES[id].level()` 이 돌려준 번들 객체를 방마다 들고 쓴다(`shared/episode-rules.ts`).
 */

import * as DEFAULT from './level-saholv7.bundle';

/** 에피소드 레벨 번들의 모양 — 모든 `level-<ep>.bundle.ts` 가 이 이름들을 전부 내보내야 한다 */
export type LevelBundle = typeof DEFAULT;

export type { Archetype, BuildingDef, ForensicDef, FurnDef, HouseStyle, LampDef, LinkDef, LockDef, LockKind, OpeningOverride, OutdoorDef, PropDef, PropKind, RoadDef, RoomDef, RoundDef, RoundMode, TreeDef, WallDef, WallRunDef } from './level-saholv7.bundle';

/** 지금 꽂힌 에피소드 id */
export let CURRENT_EPISODE = 'saholv7';

export let BODY_PARTS = DEFAULT.BODY_PARTS;
export let BUILDINGS = DEFAULT.BUILDINGS;
export let CLEARINGS = DEFAULT.CLEARINGS;
export let CLOTH = DEFAULT.CLOTH;
export let DARKWOOD = DEFAULT.DARKWOOD;
export let DOORWAYS = DEFAULT.DOORWAYS;
export let EYE_H = DEFAULT.EYE_H;
export let FORENSICS = DEFAULT.FORENSICS;
export let FURNITURE = DEFAULT.FURNITURE;
export let HILL_Y = DEFAULT.HILL_Y;
export let LINKS = DEFAULT.LINKS;
export let LOCKS = DEFAULT.LOCKS;
export let M_PER_MIN = DEFAULT.M_PER_MIN;
export let OUTDOOR = DEFAULT.OUTDOOR;
export let PIECES = DEFAULT.PIECES;
export let PLAYER_R = DEFAULT.PLAYER_R;
export let PROPS = DEFAULT.PROPS;
export let PROP_BY_ID = DEFAULT.PROP_BY_ID;
export let RAMPS = DEFAULT.RAMPS;
export let ROADS = DEFAULT.ROADS;
export let ROOMS = DEFAULT.ROOMS;
export let ROUNDS = DEFAULT.ROUNDS;
export let LEVEL = DEFAULT.LEVEL;
export let SANDBOX = DEFAULT.SANDBOX;
export let SCHOOL_GREEN = DEFAULT.SCHOOL_GREEN;
export let SNOW = DEFAULT.SNOW;
export let STEEL = DEFAULT.STEEL;
export let WALLS = DEFAULT.WALLS;
export let WALL_H = DEFAULT.WALL_H;
export let WALL_RUNS = DEFAULT.WALL_RUNS;
export let WALL_T = DEFAULT.WALL_T;
export let WINDOWS = DEFAULT.WINDOWS;
export let WIN_Y = DEFAULT.WIN_Y;
export let WOOD = DEFAULT.WOOD;
export let initialObjects = DEFAULT.initialObjects;
export let investigateBlock = DEFAULT.investigateBlock;
export let newLinks = DEFAULT.newLinks;
export let readyPair = DEFAULT.readyPair;
export let rebuildWalls = DEFAULT.rebuildWalls;
export let roomAt = DEFAULT.roomAt;
export let roundDef = DEFAULT.roundDef;
export let spawnPoint = DEFAULT.spawnPoint;
export let squadBlock = DEFAULT.squadBlock;
export let zoneOf = DEFAULT.zoneOf;
export let zoneOpen = DEFAULT.zoneOpen;

/** 레벨을 통째로 갈아 끼운다. 씬을 짓기 전에 불러야 한다 */
export function setLevel(id: string, b: LevelBundle): void {
  CURRENT_EPISODE = id;
  BODY_PARTS = b.BODY_PARTS;
  BUILDINGS = b.BUILDINGS;
  CLEARINGS = b.CLEARINGS;
  CLOTH = b.CLOTH;
  DARKWOOD = b.DARKWOOD;
  DOORWAYS = b.DOORWAYS;
  EYE_H = b.EYE_H;
  FORENSICS = b.FORENSICS;
  FURNITURE = b.FURNITURE;
  HILL_Y = b.HILL_Y;
  LINKS = b.LINKS;
  LOCKS = b.LOCKS;
  M_PER_MIN = b.M_PER_MIN;
  OUTDOOR = b.OUTDOOR;
  PIECES = b.PIECES;
  PLAYER_R = b.PLAYER_R;
  PROPS = b.PROPS;
  PROP_BY_ID = b.PROP_BY_ID;
  RAMPS = b.RAMPS;
  ROADS = b.ROADS;
  ROOMS = b.ROOMS;
  ROUNDS = b.ROUNDS;
  LEVEL = b.LEVEL;
  SANDBOX = b.SANDBOX;
  SCHOOL_GREEN = b.SCHOOL_GREEN;
  SNOW = b.SNOW;
  STEEL = b.STEEL;
  WALLS = b.WALLS;
  WALL_H = b.WALL_H;
  WALL_RUNS = b.WALL_RUNS;
  WALL_T = b.WALL_T;
  WINDOWS = b.WINDOWS;
  WIN_Y = b.WIN_Y;
  WOOD = b.WOOD;
  initialObjects = b.initialObjects;
  investigateBlock = b.investigateBlock;
  newLinks = b.newLinks;
  readyPair = b.readyPair;
  rebuildWalls = b.rebuildWalls;
  roomAt = b.roomAt;
  roundDef = b.roundDef;
  spawnPoint = b.spawnPoint;
  squadBlock = b.squadBlock;
  zoneOf = b.zoneOf;
  zoneOpen = b.zoneOpen;
}
